import { accentTokens } from './VizAccents';

/**
 * Shared 0–100 scoring color scale — a "cool = healthy, warm = needs attention"
 * maturity ramp (Leading → brand indigo, Established → periwinkle, Emerging →
 * amber, Dormant → rose). One source of truth for any metric shown as a
 * maturity/quality score — adoption scores, drift efficiency, etc. The two healthy
 * bands ride the mode-aware `--bm-chart-*` ramp so they stay legible on the dark
 * canvas; the two attention bands are theme viz-accent tokens (warm, paired).
 */
export interface ScoreBand {
    name: string;
    /** Solid band color. */
    color: string;
    /** Soft tint for chip backgrounds. */
    soft: string;
}

const AMBER = accentTokens('amber');
const ROSE = accentTokens('rose');

/** Maps a 0–100 score onto its maturity band. */
export function scoreBand(score: number): ScoreBand {
    if (score >= 75) return { name: 'Leading', color: 'var(--bm-chart-1)', soft: 'color-mix(in srgb, var(--bm-chart-1) 14%, transparent)' };
    if (score >= 50) return { name: 'Established', color: 'var(--bm-chart-2)', soft: 'color-mix(in srgb, var(--bm-chart-2) 16%, transparent)' };
    if (score >= 25) return { name: 'Emerging', color: AMBER.solid, soft: AMBER.soft };
    return { name: 'Dormant', color: ROSE.solid, soft: ROSE.soft };
}

/** Solid band color for a 0–100 score. */
export function scoreColor(score: number): string {
    return scoreBand(score).color;
}
